import BaseApiInstance from './base';
const BASE_URL = '/hub-spot-logs';

export const getJobsApi = async ({ params }) => {
  const response = await BaseApiInstance.get(`${BASE_URL}`, {
    params,
  });
  return response;
};
export const startManualSync = async () => {
  const response = await BaseApiInstance.post(`${BASE_URL}/manual-sync`);
  return response;
};
